"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedPropertyBase = void 0;
const vue_1 = require("vue");
const functions_1 = require("./functions");
const MountItem_1 = require("./MountItem");
const schemaMethods_1 = require("../schemaMethods");
const WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
const aggregateFunction_1 = require("../JSchema/aggregateFunction");
const calcFunction_1 = require("../JSchema/calcFunction");
const clearData_1 = require("../JSchema/clearData");
const clearDataDefaults_1 = require("../JSchema/clearDataDefaults");
const defaultValue_1 = require("../JSchema/defaultValue");
const defineSchema_1 = require("../JSchema/defineSchema");
const fix_parent_1 = require("../JSchema/fix$parent");
const funcParams_1 = require("../JSchema/funcParams");
const getRuleMessage_1 = require("../JSchema/getRuleMessage");
const getValidations_1 = require("../JSchema/getValidations");
const setData_1 = require("../JSchema/setData");
const setNewData_1 = require("../JSchema/setNewData");
const validFunction_1 = require("../JSchema/validFunction");
const lang_1 = require("../methods/lang");
class WrappedPropertyBase {
    /**
     * nazwa pola, dla elementów tablicy jego indeks w tablicy
     *
     * @type {(string | number)}
     * @memberof WrappedPropertyBase
     */
    get $key() {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        this.$parent && this.$parent.$setLength && this.$parent.$model; // tylko dotknięcie jesli jest tablicą
        // this.$isArrayItem && this.$parent?.$model;
        // return this._internal.key;
        return this._internal.key.value;
    }
    /**
     * nazwa pola, dla elementów tablicy jego indeks w tablicy
     *
     * @type {(string | number)}
     * @memberof WrappedPropertyBase
     */
    set $key(value) {
        this.$changeKey(value);
    }
    /**
     * wartość prosto z modelu
     *
     * @type {*}
     * @memberof WrappedPropertyBase
     */
    get $model() {
        return this._internal.parent[this._internal.key.value];
    }
    /**
     * wartośc prosto z modelu
     *
     * @memberof WrappedPropertyBase
     */
    set $model(value) {
        this._internal.parent[this._internal.key.value] = value;
    }
    /**
     * wartośc tekstowa dla pola prostego, w polach typu `array` czy `object`, to samo co w `$model`
     *
     * @type {*}
     * @memberof WrappedPropertyBase
     */
    get $value() {
        if (this._internal.debounceValue && this._internal.debounceValue.value !== undefined) {
            return this._internal.debounceValue.value;
        }
        return this.getValue();
    }
    /**
     * poprzednia wartośc pola
     */
    get $prevModel() {
        return this._internal.prevModel;
    }
    /**
     * wartośc tekstowa dla pola prostego w poprzednim modelu (do powrównania), w polach typu `array` czy `object`, to samo co w `$model`
     *
     * @type {*}
     * @memberof WrappedPropertyBase
     */
    get $prevValue() {
        if (this._internal.prevModel !== undefined) {
            return this.getValue(this._internal.prevModel);
        }
        /*
        if (this._internal.prevParent) {
          let vv = this._internal.prevParent[this._internal.key.value];
          if (vv === undefined)
            vv = this._internal.prevParent[this._internal.key.value] = defaultValue(this._internal.schema, true, undefined, this._internal.options.longGuids);
          return this.getValue(vv);
        }
          */
    }
    get $diffStatus() {
        if (this._options.prevModel) {
            if (this._internal.prevModel === undefined) {
                return 'new';
            }
            if (this._internal.prevModel !== this._internal.parent[this._internal.key.value]) {
                return 'changed';
            }
        }
        return '';
    }
    /**
     * wartośc tekstowa dla pola prostego, w polach typu `array` czy `object`, to samo co w `$model`
     *
     * @type {*}
     * @memberof WrappedPropertyBase
     */
    set $value(newValue) {
        if (this._options.logWarnings) {
            // sprawdzam czy czasem nie ma calc lub aggreagate
            if (this._internal.schema.calc && !this._internal.schema.calc.when) {
                (0, functions_1.logWarning)(this, 'set field computed by `calc`', '');
            }
            else if (this._internal.schema.aggregate) {
                (0, functions_1.logWarning)(this, 'set field computed by `aggreagate`', '');
            }
        }
        if (this._internal.debounce) {
            (0, functions_1.debounceRun)(this._internal, newValue, () => {
                this.setValue(newValue);
            });
        }
        else {
            this.setValue(newValue);
        }
    }
    /**
     * dostęp do zmiennej `form` bazowego komponentu
     *
     * @readonly
     * @type {*}
     * @memberof WrappedPropertyBase
     */
    get $form() {
        return this._internal.options.form;
    }
    /**
     * dostęp do danych zewnętrznych
     *
     * @type {*}
     * @memberof WrappedPropertyBase
     */
    get $external() {
        return this._internal.options.external;
    }
    /**
     * dostęp do danych zewnętrznych
     *
     * @type {*}
     * @memberof WrappedPropertyBase
     */
    set $external(external) {
        if ((0, vue_1.isReactive)(external)) {
            this._internal.options.external = external;
        }
        else {
            this._internal.options.external = (0, vue_1.readonly)(external);
        }
    }
    /**
     * obiekt danych użytkownika, można dodawać dowolne pola
     *
     * @readonly
     * @type {*}
     * @memberof WrappedPropertyBase
     */
    get $data() {
        if (this._internal.vmUserData === null) {
            // odczyt ze schematu jeśli są
            const userData = this._internal.schema.data ? Object.assign({}, this._internal.schema.data) : {};
            this._internal.vmUserData = (0, vue_1.reactive)(userData);
        }
        return this._internal.vmUserData;
    }
    /**
     * komunikat błędu, lub null
     *
     * @readonly
     * @type {(string | null)}
     * @memberof WrappedPropertyBase
     */
    get $error() {
        //rejestrowanie dostępu do $error
        if (this._options._readedErrorFields)
            this._options._readedErrorFields.add(this);
        if (!this.$disabled && this.$dirty) {
            return this.$validate();
        }
        else {
            return null;
        }
    }
    /**
     * lista ostrzeżeń
     *
     * @readonly
     * @type {string[]}
     * @memberof WrappedPropertyBase
     */
    get $warnings() {
        if (!this.$disabled && this.$dirty) {
            return this.$check();
        }
        else {
            return [];
        }
    }
    /**
     * czy element był "dotykany"
     *
     * @type {boolean}
     * @memberof WrappedPropertyBase
     */
    get $dirty() {
        return this.$getUserData('$dirty', this._options.startDirty);
    }
    /**
     * czy element był "dotykany"
     *
     * @type {boolean}
     * @memberof WrappedPropertyBase
     */
    set $dirty(newValue) {
        var _a;
        if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.dirty) {
            const prevValue = this.$dirty;
            if (newValue != prevValue) {
                this.$setUserData('$dirty', newValue);
                (0, functions_1.runEvent)({ target: this, type: 'dirty', value: newValue, prevValue: prevValue });
            }
        }
        else {
            this.$setUserData('$dirty', newValue);
        }
        if (newValue) {
            // debugger;
            this._options._userInput = true;
        }
    }
    /**
     * pełna ścieżka do pola
     *
     * @readonly
     * @type {string}
     * @memberof WrappedPropertyBase
     */
    get $path() {
        // const result = '';
        if (this.$parent) {
            if (this.$parent.$schema.type === 'array') {
                return this.$parent.$path + '[' + this.$key + ']';
            }
            const ppath = this.$parent.$path;
            if (ppath) {
                return ppath + '.' + this.$key;
            }
            else {
                return this.$key.toString();
            }
        }
        return '';
    }
    /**
     * ścieżka do pola, ale bez indeksów tabel
     *
     * @readonly
     * @type {string}
     * @memberof WrappedPropertyBase
     */
    get $langPath() {
        // const result = '';
        if (this.$parent) {
            const ppath = this.$parent.$langPath;
            if (this.$parent.$schema.type === 'array') {
                return ppath;
            }
            if (ppath) {
                return ppath + '.' + this.$key;
            }
            else {
                return this.$key.toString();
            }
        }
        return this._options.langKeyPrefix || '';
    }
    /**
     * czy pole ma fokus
     *
     * @type {boolean}
     * @memberof WrappedPropertyBase
     */
    get $hasFocus() {
        return this.$getUserData('$focused', false);
    }
    /**
     * czy pole ma fokus
     *
     * @memberof WrappedPropertyBase
     */
    set $hasFocus(newValue) {
        var _a, _b;
        if (newValue) {
            if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.focus) {
                const prevValue = this.$hasFocus;
                if (!prevValue) {
                    this.$setUserData('$focused', true);
                    (0, functions_1.runEvent)({
                        type: 'focus',
                        target: this,
                        value: true,
                        prevValue: false
                    });
                }
            }
            else {
                this.$setUserData('$focused', true);
            }
            if (this._internal.options.resetOnFocus) {
                this.$reset();
            }
        }
        else {
            if (this._internal.debounce) {
                if (this._internal.debounceValue && this._internal.debounceValue.value !== undefined) {
                    this.setValue(this._internal.debounceValue.value);
                }
                clearTimeout(this._internal.debounceTimer);
            }
            if ((_b = this._options._anyEvent) === null || _b === void 0 ? void 0 : _b.blur) {
                const prevValue = this.$hasFocus;
                if (prevValue) {
                    this.$setUserData('$focused', false);
                    (0, functions_1.runEvent)({
                        type: 'blur',
                        target: this,
                        value: true,
                        prevValue: false
                    });
                }
            }
            else {
                this.$setUserData('$focused', false);
            }
            if (!this.$disabled && !this.$dirty && this._options.dirtyOnBlur) {
                // console.log('set $dirty', this.$path);
                this.$dirty = true;
            }
        }
    }
    /**
     * pobranie tytułu pola, `title` w schema
     *
     * @readonly
     * @type {string}
     * @memberof WrappedPropertyBase
     */
    get $title() {
        let tt = this.$schema.title;
        if (this._options._i18n) {
            if (!tt && this._options.langKeyPrefix !== undefined) {
                tt = this.$langPath;
            }
            if (tt)
                return this._options._i18n.value.t(tt);
        }
        return tt || '';
        // return this.$schema.title ?
        //  (this._options._lang?.value.i18n ? this._options._lang?.value.i18n.t(this.$schema.title) : this.$schema.title) : '';
    }
    /**
     * pobranie skróconego tytułu pola, `shortTitle` w schema
     *
     * @readonly
     * @type {string}
     * @memberof WrappedPropertyBase
     */
    get $shortTitle() {
        if (this.$schema.shortTitle !== undefined) {
            return this._options._i18n ? this._options._i18n.value.t(this.$schema.shortTitle) : this.$schema.shortTitle;
        }
        return this.$title;
    }
    /**
     * pobranie opisu pola, `description` w schema
     *
     * @readonly
     * @type {string}
     * @memberof WrappedPropertyBase
     */
    get $description() {
        if (this.$schema.description) {
            return this._options._i18n ? this._options._i18n.value.t(this.$schema.description) : this.$schema.description;
        }
        return '';
    }
    /**
     * pobranie dopuszczalnych wartości pola, `enum` w schema
     * pusta tablica gdy brak definicji
     *
     * @readonly
     * @type {Array}
     * @memberof WrappedPropertyBase
     */
    get $enum() {
        return this.$schema.enum || [];
    }
    /**
     * czy element jest wyłączony, sprawdza również obiekty nadrzędne
     *
     * @readonly
     * @type {boolean}
     * @memberof WrappedPropertyBase
     */
    get $disabled() {
        return (0, functions_1.anyDisabled)(this);
    }
    /**
     * odwrotnośc $disabled
     *
     * @readonly
     * @type {boolean}
     * @memberof WrappedPropertyBase
     */
    get $enabled() {
        return !(0, functions_1.anyDisabled)(this);
    }
    /**
     * czy pole lub root jest readOnly
     */
    get $readOnly() {
        /*
        if ((this.$root) && (this.$root !== this) && this.$root.readOnly) {
          return true;
        }
        */
        if (this.$parent && this.$parent.$readOnly) {
            return true;
        }
        let value = this.$getUserData('readOnly', null);
        if (value === null) {
            value = this.$schema.readOnly;
        }
        return !!value;
    }
    /**
     * czy pole lub root jest readOnly, ustawienie undefined powraca do czytania z $schema
     */
    set $readOnly(value) {
        this.$setUserData('readOnly', value ? true : null);
    }
    /**
     * ustawienia csv
     */
    get $csv() {
        return this._internal.schema.csv;
    }
    /**
     * czy to jest element tablicy ?
     *
     * @readonly
     * @memberof WrappedPropertyBase
     */
    get $isArrayItem() {
        // return !!this.$parent && this.$parent.$schema.type === 'array';
        return this.$parent && this.$parent.$setLength && typeof this._internal.key.value === 'number';
    }
    /**
     * zwraca indeks w tablicy, najbliżej elementowi
     */
    get $arrayIndex() {
        if (this.$isArrayItem) {
            return this._internal.key.value;
        }
        if (this.$parent) {
            return this.$parent.$arrayIndex;
        }
        return -1;
    }
    constructor(internal, internalFixFunc) {
        var _a, _b, _c;
        /**
         * pełny wynik validacji po $validate
         *
         * @type {(IValidateResult | null)}
         * @memberof IWrappedProperty
         */
        this.$validateResult = null;
        /**
         * pełny wynik sprawdzania ostrzeżeń
         *
         * @type {IValidateResult[]}
         * @memberof IWrappedProperty
         */
        this.$checkResult = [];
        this.$parent = internal.dest;
        // markRaw(this);  // zabezpieczenie zeby Vue3 nie traktowało go reaktywnie
        const options = (this._options = internal.options);
        if (!internal.key) {
            if (typeof internal.propName === 'string') {
                internal.key = { value: internal.propName };
            }
            else {
                internal.key = (0, vue_1.ref)(internal.propName);
            }
        }
        internal.vmUserData = null;
        internal.mparent = null;
        internal.watchStops = [];
        this._internal = internal;
        const schema = internal.schema;
        const dest = internal.dest;
        const propName = internal.key.value;
        const parent = internal.parent;
        if (schema.type == 'array' || (dest && dest._internal.funcCache))
            internal.funcCache = true;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        // jednak nie ma potrzeby, bo props jednak jest `shallowReactive`
        // this.__v_isReadonly = true; //zapobieganie aby Vue3 nie robiło reactive na nim
        // root
        if (dest) {
            this.$root = dest.$root;
        }
        else {
            this.$root = this;
        }
        // create schema
        const $schema = (this.$schema = {
            type: schema.type
        });
        // default value
        if (schema.default !== undefined) {
            if ((0, defineSchema_1.isFunction)(schema.default)) {
                (0, functions_1.wrapSchemaProp)(this, 'default', internal);
            }
            else {
                $schema.default = schema.default;
            }
        }
        // default value
        if (parent[propName] === undefined) {
            if ((0, defineSchema_1.isFunction)(schema.default)) {
                parent[propName] = $schema.default;
                /*
                
                const func = schema.default;
                const ctx = {
                  $root: dest ? this.$root.$model : internal.mparent,
                  $external: internal.options.external || {},
                  $methods: internal.options.schemaMethods,
                  $obj: this,
                  $parent: dest ? dest.$model : {},
                  $parent2: dest && dest.$parent ? dest.$parent.$model : {},
                  $parent3: dest && dest.$parent2 ? dest.$parent2.$model : {}
                };
                const thisModel = createCtxProxy({
                  options: internal.options,
                  parent: dest ? parent : internal.mparent,
                  calcCtx: ctx
                } as any);
                parent[propName] = func.call(thisModel || (dest ? parent : internal.mparent), ctx);
                */
            }
            else {
                parent[propName] = (0, defaultValue_1.defaultValue)(schema, true, undefined, this._internal.options, this.$path);
            }
        }
        internal.mparent = parent[propName];
        (0, functions_1.wrapSchemaProps)(this, internal, 'string', ['title', 'shortTitle', 'description']);
        if (internalFixFunc) {
            internalFixFunc(this._internal);
        }
        // sthis._options.external;
        if (schema.$on && !options.disableCalculations) {
            for (const key in schema.$on) {
                let argName = 'event';
                let funcText = schema.$on[key];
                if ((0, defineSchema_1.isFunction)(funcText)) {
                    switch (key) {
                        case 'beforeWrap':
                            {
                                // if (options.disableCalculations) continue;
                                // przygotuj ctx
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
                                const func = funcText;
                                //let ctx: any = undefined;
                                //if (funcText.length > 1) {
                                if (!internal.calcCtx)
                                    (0, functions_1.initCtx)(this, internal);
                                const thisModel = (0, functions_1.createCtxProxy)({
                                    options: internal.options,
                                    // parent: internal.mparent,
                                    // parent, // bo to proxy, a mparent nie
                                    parent: dest ? parent : internal.mparent,
                                    calcCtx: internal.calcCtx
                                });
                                //}
                                try {
                                    const result = func.call(thisModel /*dest ? parent : internal.mparent*/, { target: this, type: 'beforeWrap', value: null, prevValue: null }, internal.calcCtx);
                                    if (result !== undefined) {
                                        this.$setData(result, undefined, true);
                                    }
                                }
                                catch (err) {
                                    (0, functions_1.logError)(this, 'beforeWrap', err, funcText);
                                }
                            }
                            break;
                        default:
                            {
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
                                const func = funcText;
                                if (!internal.calcCtx)
                                    (0, functions_1.initCtx)(this, internal);
                                if (!internal.thisModel)
                                    internal.thisModel = (0, functions_1.createCtxProxy)(internal);
                                this.$on(key, func);
                            }
                            break;
                    }
                }
                else {
                    if (funcText.body) {
                        if (funcText.args) {
                            argName = funcText.args.split(',')[0];
                        }
                        funcText = funcText.body;
                    }
                    let ftext = '';
                    if (Array.isArray(funcText)) {
                        funcText = funcText.join('\r\n');
                        ftext = (0, fix_parent_1.fix$parent)(funcText) + '\r\n';
                    }
                    else {
                        ftext = (0, fix_parent_1.fix$parent)(funcText);
                    }
                    switch (key) {
                        case 'beforeWrap':
                            {
                                //const func = new Function(argName + "," + funcParams, ftext);
                                const func = new Function(argName + ',{' + funcParams_1.funcParams + '}', ftext);
                                if (!internal.calcCtx)
                                    (0, functions_1.initCtx)(this, internal);
                                try {
                                    const result = func.call(dest ? parent : internal.mparent, { target: this, type: 'beforeWrap', value: null, prevValue: null }, internal.calcCtx);
                                    if (result != undefined) {
                                        this.$setData(result, undefined, true);
                                    }
                                }
                                catch (err) {
                                    (0, functions_1.logError)(this, 'beforeWrap', err, funcText);
                                }
                            }
                            break;
                        default:
                            {
                                const func = new Function(argName + ',{' + funcParams_1.funcParams + '}', ftext);
                                this.$on(key, func);
                            }
                            break;
                    }
                }
            }
        }
        if (schema.format) {
            $schema.format = schema.format;
        }
        // wrap schema.emun
        if (schema.enum !== undefined && schema.type !== 'object' && schema.type !== 'array') {
            if (self.$isArrayItem) {
                if (!Array.isArray(schema.enum) || (typeof schema.enum[0] == 'string' && schema.type != 'string')) {
                    (0, functions_1.wrapSchemaProp)(this, 'enum', internal, (newValue) => {
                        if (newValue) {
                            const mvalue = self.$model;
                            // console.log(`s: sprawadzam ${mvalue} w ${newValue} elementowej`)
                            if (mvalue !== undefined && newValue.indexOf(mvalue) === -1) {
                                // console.log(`e: do usunięcia ${self.$model}`)
                                (0, vue_1.nextTick)(() => {
                                    // console.log(`s: usuwam ${self.$model}`)
                                    self.$removeRow();
                                });
                            }
                            /*
                            setTimeout(() => {
                              self.$removeRow();
                            });
                            */
                        }
                    });
                }
                else {
                    this.$schema.enum = schema.enum;
                    const mvalue = self.$model;
                    // console.log(`e: sprawadzam ${mvalue} w ${this.$schema.enum} elementowej`)
                    if (mvalue !== undefined && ((_a = this.$schema.enum) === null || _a === void 0 ? void 0 : _a.indexOf(mvalue)) === -1) {
                        // console.log(`e: do usunięcia ${self.$model}`)
                        (0, vue_1.nextTick)(() => {
                            //  console.log(`e: usuwam ${self.$model}`)
                            self.$removeRow();
                        });
                        /*
                        setTimeout(() => {
                          self.$removeRow();
                        }, 0);
                        */
                    }
                }
                // simple elems, autovalidations
                //if (schema.type !== 'object' && schema.type !== 'array')
                {
                    const wenum = (0, vue_1.watch)(() => this.$model, (newValue) => {
                        var _a;
                        if (newValue !== undefined && ((_a = this.$schema.enum) === null || _a === void 0 ? void 0 : _a.indexOf(newValue)) === -1) {
                            self.$removeRow();
                            // nextTick(() => {
                            //  self.$removeRow();
                            //});
                        }
                    });
                    this._internal.watchStops.push(wenum);
                }
            }
            else {
                if (!Array.isArray(schema.enum) || (typeof schema.enum[0] == 'string' && schema.type != 'string')) {
                    (0, functions_1.wrapSchemaProp)(this, 'enum', internal);
                }
                else {
                    this.$schema.enum = schema.enum;
                }
            }
        }
        if (schema.debounce) {
            // debugger;
            this._internal.debounce = schema.debounce;
            this._internal.debounceValue = (0, vue_1.ref)();
        }
        // wrap schema.required
        if (schema.required !== undefined &&
            schema.type !== 'object' &&
            (typeof schema.required === 'string' || typeof schema.required === 'boolean')) {
            schema.fieldRequired = schema.required;
        }
        (0, functions_1.wrapSchemaProps)(this, internal, 'boolean', ['fieldRequired']);
        if (options.readOnly) {
            $schema.readOnly = true;
        }
        else {
            (0, functions_1.wrapSchemaProps)(this, internal, 'boolean', ['readOnly']);
        }
        // wrap schema.disabled
        if (internal.schema.disabled !== undefined) {
            let prevDirty = false;
            const disFunc = (disabled) => {
                if (disabled) {
                    if (!internal.options._disabledFields)
                        internal.options._disabledFields = new Set();
                    internal.options._disabledFields.add(this.$path);
                    prevDirty = this.$data['$dirty']; // this.$dirty; // zapamiętanie czy pole było odwiedzane
                    if (prevDirty) {
                        this.$dirty = false;
                    }
                    let defValue;
                    if (schema.type === 'array') {
                        // zeby pominąc length
                        // debugger;
                        if (schema.default) {
                            if ((0, defineSchema_1.isFunction)(schema.default)) {
                                defValue = $schema.default;
                            }
                            else if (typeof schema.default === 'number') {
                                defValue = [];
                            }
                            else {
                                defValue = Array.from($schema.default);
                            }
                        }
                        else {
                            defValue = [];
                        }
                    }
                    else {
                        // defValue = defaultValue(schema, false);
                        if ((0, defineSchema_1.isFunction)(schema.default)) {
                            defValue = $schema.default;
                        }
                        else {
                            defValue = (0, defaultValue_1.defaultValue)(schema, true, undefined, this._internal.options, this.$path);
                        }
                    }
                    if (defValue === undefined) {
                        // gdy nie ma domyslnej wartości usuń z modelu === undefined
                        // options.Vue.delete(parent, propName);
                        // jednak lepiej nie usuwać, bo traci się wszystkie połczenia dynamiczne z Vue
                        // this.$setData(undefined);
                        parent[propName] = undefined;
                    }
                    else {
                        // ustaw domyślną wartość
                        this.$setData(defValue, undefined, true);
                    }
                    // zapamietanie w $root któ®e są wyłączone
                }
                else {
                    if (internal.options._disabledFields)
                        internal.options._disabledFields.delete(this.$path);
                    if (prevDirty) {
                        this.$dirty = prevDirty; // przywrócenie informacji że pole było odwiedzone
                    }
                    // console.log('restore disabled', parent[propName]), defaultValue(schema, true);
                    const prevValue = parent[propName];
                    if (parent[propName] === undefined) {
                        // w przypadku gdy w polu jest indefined to ustawić domyslną wartośc
                        if ((0, defineSchema_1.isFunction)(schema.default)) {
                            parent[propName] = $schema.default;
                        }
                        else {
                            parent[propName] = (0, defaultValue_1.defaultValue)(schema, true, undefined, this._internal.options, this.$path);
                        }
                        this._internal.mparent = parent[propName];
                    }
                    else if (schema.type === 'array') {
                        if ($schema.length !== undefined) {
                            this.$setLength($schema.length);
                        }
                        else if (typeof schema.default === 'number' && (!prevValue || prevValue.length === 0)) {
                            this.$setLength(schema.default);
                        }
                    }
                }
            };
            if (typeof internal.schema.disabled !== 'boolean') {
                if (!options.disableCalculations) {
                    (0, functions_1.wrapSchemaProp)(this, 'disabled', internal, (newValue /*, oldValue: boolean*/) => {
                        disFunc(newValue);
                    });
                    if ($schema.disabled) {
                        disFunc(true);
                    }
                }
            }
            else {
                this.$schema.disabled = internal.schema.disabled;
                if (internal.schema.disabled) {
                    disFunc(true);
                    /*
                    let defValue: any;
                    if (schema.type === 'array') {
                      // zeby pominąc length
                      // debugger;
                      if (schema.default) {
                        defValue = Array.from(schema.default);
                      } else {
                        defValue = [];
                      }
                    } else {
                      // defValue = defaultValue(schema, false);
                      if (isFunction(schema.default)) {
                        defValue = $schema.default;
                      } else {
                        defValue = defaultValue(schema, true, undefined, this._internal.options, this.$path);
                      }
                    }
          
                    if (defValue === undefined) {
                      parent[propName] = undefined;
                      // options.Vue.delete(parent, propName);
                    } else {
                      this.$setData(defValue);
                    }
                      */
                }
            }
        }
        /*
        if (schema.fieldRequired !== undefined) {
          if (typeof schema.fieldRequired !== 'boolean') {
            wrapSchemaProp(this, 'fieldRequired', internal, 'boolean');
          } else {
            this.$schema.fieldRequired = schema.fieldRequired;
          }
        }
        */
        // tworzenie funkcji validującej
        if (!internal.options.disableValidations && schema.validFunc) {
            let validFunc;
            if (!internal.calcCtx)
                (0, functions_1.initCtx)(this, internal);
            if ((0, defineSchema_1.isFunction)(schema.validFunc)) {
                validFunc = schema.validFunc;
                if (!internal.thisModel)
                    internal.thisModel = (0, functions_1.createCtxProxy)(internal);
            }
            else {
                validFunc = (0, validFunction_1.validFunction)(schema, schema.validFunc, true, process.env.NODE_ENV !== 'production' && schema.debug);
            }
            // var needValue = validFunc.toString().indexOf("$value") > -1;
            //is async
            let validCount = 0;
            const validFuncResult = (0, vue_1.ref)();
            //let isSync: boolean | null = null; //check on first run
            let isSync = true; //od razu odpalaj
            let checkSync = true;
            const vfunc = () => {
                const validId = ++validCount;
                try {
                    // const pvalue = validFunc.apply(parent, internal.calcargs);
                    if (internal.calcCtx) {
                        internal.calcCtx.$value = this.$model;
                    }
                    const pvalue = validFunc.call(internal.thisModel || parent, internal.calcCtx);
                    if (checkSync) {
                        isSync = !(0, functions_1.isPromise)(pvalue);
                        checkSync = false;
                    }
                    if (isSync) {
                        //if (!isPromise(pvalue)) {
                        if (pvalue === true || pvalue === undefined) {
                            return (validFuncResult.value = null);
                        }
                        if (pvalue === false) {
                            return (validFuncResult.value = 'validFunc');
                        }
                        return (validFuncResult.value = pvalue);
                    }
                    else {
                        Promise.resolve(pvalue).then((funcvalue) => {
                            if (validId === validCount) {
                                //czy czasem nie było wcześniej wywołania
                                if (funcvalue === true || funcvalue === undefined) {
                                    return (validFuncResult.value = null);
                                }
                                if (funcvalue === false) {
                                    return (validFuncResult.value = 'validFunc');
                                }
                                return (validFuncResult.value = funcvalue);
                            }
                        });
                    }
                }
                catch (err) {
                    (0, functions_1.logError)(this, 'validFunc', err, schema.validFunc);
                }
            };
            const vfstop = (0, vue_1.watchEffect)(vfunc);
            internal.watchStops.push(vfstop);
            Object.defineProperty($schema, 'validFunc', {
                enumerable: true,
                get() {
                    return validFuncResult.value;
                }
            });
            /*
            internal.watch.validFunc = {
              handler: (newValue: any, oldValue: any) => {
                if (self.$dirty) {
                  self.$validate();
                }
              },
              immediate: false
            };
            */
        }
        // warning
        if (schema.warnings) {
            this.$schema.warnings = {};
            (0, functions_1.wrapWarningProps)(this, internal, 'boolean', ['fieldRequired']);
            // format
            if (schema.warnings.format) {
                this.$schema.warnings.format = schema.warnings.format;
            }
            // enum
            if (schema.warnings.enum !== undefined && schema.type !== 'object' && schema.type !== 'array') {
                if (!Array.isArray(schema.warnings.enum) ||
                    (typeof schema.warnings.enum[0] == 'string' && schema.type != 'string')) {
                    (0, functions_1.wrapWarningProp)(this, 'enum', internal);
                }
                else {
                    this.$schema.warnings.enum = schema.warnings.enum;
                }
            }
            if (!options.disableValidations && schema.warnings.validFunc) {
                // internal.needsCalcArgs = true
                // if (!internal.calcargs)
                //  initVue(this, internal);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
                let validFunc;
                if (!internal.calcCtx)
                    (0, functions_1.initCtx)(this, internal);
                if ((0, defineSchema_1.isFunction)(schema.warnings.validFunc)) {
                    validFunc = schema.warnings.validFunc;
                    if (!internal.thisModel)
                        internal.thisModel = (0, functions_1.createCtxProxy)(internal);
                }
                else {
                    validFunc = (0, validFunction_1.validFunction)(schema, schema.warnings.validFunc, true, process.env.NODE_ENV !== 'production' && schema.debug);
                }
                /*
        
                if (validFunc.length && !internal.calcCtx) {
                  initCtx(this, internal);
                }
                */
                const validComputed = (0, vue_1.computed)(() => {
                    // const funcvalue = validFunc.apply(parent, internal.calcargs);
                    if (internal.calcCtx) {
                        internal.calcCtx.$value = this.$model;
                    }
                    const funcvalue = validFunc.call(internal.thisModel || parent, internal.calcCtx);
                    if (funcvalue === true || funcvalue === undefined) {
                        return null;
                    }
                    if (funcvalue === false) {
                        return 'validFunc';
                    }
                    return funcvalue;
                });
                Object.defineProperty($schema, 'warningValidFunc', {
                    enumerable: true,
                    get() {
                        return validComputed.value;
                    }
                });
                /*
                internal.watch.validFunc = {
                  handler: (newValue: any, oldValue: any) => {
                    if (self.$dirty) {
                      self.$validate();
                    }
                  },
                  immediate: false
                };
                */
            }
        }
        if (!self._options.disableCalculations) {
            // tworzenie funkcji wyliczjącej wartośc na podstawie innych pól
            if (schema.calc) {
                let calcFunc;
                // let argsInThis = false;
                //let thisModel: any;
                if (!internal.calcCtx)
                    (0, functions_1.initCtx)(this, internal);
                if ((0, defineSchema_1.isFunction)(schema.calc)) {
                    calcFunc = schema.calc;
                    if (!internal.thisModel)
                        internal.thisModel = (0, functions_1.createCtxProxy)(internal);
                }
                else {
                    calcFunc = (0, calcFunction_1.calcFunction)(schema, internal.funcCache, process.env.NODE_ENV !== 'production' && schema.debug);
                    // thisModel = parent;
                }
                // jesli jest potrzebny argument wejsciowy
                /*
                if (!internal.calcCtx && calcFunc.length)
                  initCtx(this, internal);
        */
                let calcCount = 0;
                let res = undefined;
                let touchFunc = undefined;
                if (schema.type === 'object' || schema.type === 'array') {
                    let body = 'return deepCopy(obj);';
                    if (schema.type === 'object') {
                        const pp = schema.properties || {};
                        const keys = Object.keys(pp);
                        body = keys
                            .map((x) => pp[x].type === 'array' || pp[x].type === 'object'
                            ? `obj.${x}===undefined ? undefined : deepCopy(obj.${x})`
                            : `obj.${x}`)
                            .join(',');
                    }
                    else {
                        if (((_b = schema.items) === null || _b === void 0 ? void 0 : _b.type) !== 'object' && ((_c = schema.items) === null || _c === void 0 ? void 0 : _c.type) !== 'array') {
                            //body = "obj.map(x=>x)"
                            touchFunc = function (obj /*, deepCopy: any*/) {
                                if (obj) {
                                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                    for (let i = 0; i < obj.length; i++)
                                        obj[i];
                                }
                            };
                        }
                    }
                    if (!touchFunc)
                        touchFunc = new Function('obj,deepCopy', body);
                    //ftext += 'var $result=(' + stext + '); return !$result ? null : {' + keys.map(x => ((schema.properties || {})[x].type === 'array' || (schema.properties || {})[x].type === 'object') ? x + ': $result.' + x + '===undefined ? undefined : $methods.deepCopy($result.' + x + ')' : x + ': $result.' + x).join(', ') + '}';
                }
                const calcValue = /*computed(*/ () => {
                    calcCount++;
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    options._forceRecalc && options._forceRecalc.value;
                    if (self.$disabled) {
                        res = undefined;
                        return calcCount;
                    }
                    try {
                        res = calcFunc.call(internal.thisModel || internal.parent, internal.calcCtx);
                        if (options.logWarnings) {
                            if ((res === undefined &&
                                schema.calc.when === undefined &&
                                typeof schema.calc === 'string' &&
                                schema.calc.indexOf('undefined') === -1) ||
                                // tslint:disable-next-line: use-isnan
                                (typeof res === 'number' && isNaN(res))) {
                                (0, functions_1.logWarning)(self, `calc result: ${JSON.stringify(res)}`, schema.calc);
                            }
                        }
                        if (res && (schema.type === 'object' || schema.type === 'array')) {
                            //żeby dotykało każdej właściwosći
                            touchFunc(res, schemaMethods_1.deepCopy);
                        }
                    }
                    catch (err) {
                        (0, functions_1.logError)(self, 'calc', err, schema.calc);
                        res = undefined;
                    }
                    // return calcCount;
                    return calcCount;
                }; /*)*/
                const calcStop = (0, vue_1.watch)(calcValue, ( /* newValue: any */) => {
                    if (res !== undefined) {
                        if (self._options.startDirtyOnCalc || self._options._userInput) {
                            if ((self._options.dirtyOnBlur || self._options.dirtyOnInput) && !self.$dirty) {
                                self.$dirty = true;
                            }
                        }
                        if (this._internal.debounce) {
                            (0, functions_1.debounceRun)(this._internal, res, () => {
                                self.$setData(res, undefined, true);
                            });
                        }
                        else {
                            self.$setData(res, undefined, true);
                        }
                    }
                }, {
                    immediate: true
                });
                internal.watchStops.push(calcStop);
                // computed.calc = calcFunc;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.summary) {
                schema.aggregate = {
                    func: 'sum',
                    array: schema.summary.array,
                    property: schema.summary.property,
                    when: schema.summary.when,
                    if: schema.summary.if,
                    delay: schema.summary.delay
                };
                delete schema.summary;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.aggregate) {
                // internal.needsCalcArgs = true;
                if (!internal.calcCtx)
                    (0, functions_1.initCtx)(this, internal);
                const aggregateFunc = (0, aggregateFunction_1.aggregateFunction)(schema, internal.funcCache, process.env.NODE_ENV !== 'production' && schema.debug);
                if (aggregateFunc) {
                    const calcValue = /*computed(*/ () => {
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        options._forceRecalc && options._forceRecalc.value;
                        if (self.$disabled) {
                            return undefined;
                        }
                        // console.log('run agg', self.internal);
                        try {
                            const res = aggregateFunc.call(parent, internal.calcCtx);
                            if (options.logWarnings) {
                                if (res === undefined || (isNaN(res) && typeof res === 'number')) {
                                    (0, functions_1.logWarning)(self, `aggregate result: ${JSON.stringify(res)}`, schema.aggregate);
                                }
                            }
                            return res;
                        }
                        catch (err) {
                            (0, functions_1.logError)(self, 'aggregate', err, schema.aggregate);
                            return undefined;
                        }
                        // return aggregateFunc()
                    }; /*)*/
                    const watchFunc = (newValue) => {
                        if (newValue !== undefined) {
                            if (self._options.startDirtyOnCalc || self._options._userInput) {
                                if (!self.$dirty && (self._options.dirtyOnBlur || self._options.dirtyOnInput)) {
                                    self.$dirty = true;
                                }
                            }
                            self.$setData(newValue, undefined, true);
                        }
                    };
                    // if (schema.aggregate.async) {
                    if (schema.aggregate.delay) {
                        setTimeout(() => {
                            // console.log('delayed create aggregate',obj.$path);
                            const aggStop = (0, vue_1.watch)(calcValue, watchFunc, {
                                immediate: true
                            });
                            internal.watchStops.push(aggStop);
                            //  this.vueInstances.push(asyncVm);
                        }, schema.aggregate.delay);
                    }
                    else {
                        const aggStop = (0, vue_1.watch)(calcValue, watchFunc, {
                            immediate: true
                        });
                        internal.watchStops.push(aggStop);
                    }
                }
            }
        }
    }
    /*
    $setNewJsonData(jsonValue: string, path?: string | undefined): boolean {
      throw new Error('Method not implemented.');
    }
    $getJsonData(checkDataType?: boolean | undefined, path?: string | undefined): string {
      throw new Error('Method not implemented.');
    }
    $setJsonData(jsonValue: string, path?: string | null | undefined, fixArraySize?: boolean | undefined): boolean {
      throw new Error('Method not implemented.');
    }
    */
    /**
     * ustawienie $hasFocus na tru
     *
     * @memberof WrappedPropertyBase
     */
    $focus(event) {
        if (event && event.target) {
            // console.log('$focus(event)', this._internal)
            this._internal.targetElement = event.target;
        }
        this.$hasFocus = true;
    }
    /**
     * ustawienie $hasFocus na false
     *
     * @memberof WrappedPropertyBase
     */
    $blur(event) {
        if (event && event.target) {
            // console.log('$focus(event)', this._internal)
            this._internal.targetElement = event.target;
        }
        this.$hasFocus = false;
    }
    $bind(el, modifiers) {
        // console.log('$mount', this.$path, el, typeof el === "string");
        var _a;
        if (typeof el === 'string') {
            const fel = document.querySelector(el);
            if (!fel) {
                return null;
            }
            else {
                el = fel;
            }
        }
        el = el;
        if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
            const mi = new MountItem_1.MountItem(el);
            let isNumberField = false;
            // const cssClassPrefix = 'jschema-';
            switch (this.$schema.type) {
                case 'number':
                case 'integer':
                case 'money':
                    isNumberField = true;
                    break;
            }
            // monitorowanie $error
            /*
            mi.watch(() => this.$error, (newValue) => {
              console.log('error', newValue);
              if (newValue) {
                el.classList.add(cssClassPrefix + 'error');
              } else {
                el.classList.remove(cssClassPrefix + 'error');
              }
            });
            */
            /*
            if (isNumberField) {
              el.classList.add(cssClassPrefix + 'number');
            }
            */
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const self = this;
            mi.event('focus', (event) => {
                // console.log('focus', self.$path);
                mi.hasFocus = true;
                self.$focus(event);
            });
            mi.event('blur', (event) => {
                // console.log('blur', self.$path);
                mi.hasFocus = false;
                if (isNumberField) {
                    el.value = this.$value;
                }
                self.$blur(event);
            });
            // checkbox
            if (el.tagName === 'INPUT' && (el.type == 'checkbox' || el.type == 'radio')) {
                let cvalue = el.value;
                if (this.$schema.type == 'boolean') {
                    cvalue = (cvalue || 'true') !== 'false';
                    const ncvalue = !cvalue;
                    mi.event('change', ( /* event: Event */) => {
                        // this.$model = !!(el as any).checked as any;
                        self.$model = el.checked ? cvalue : ncvalue;
                    });
                    // change
                    mi.watch(() => this.$model, (newValue) => {
                        el.checked = newValue == cvalue;
                    }, true);
                    /*
                    let negative = cvalue === 'false';
                    if (negative) {
                      (el as any).checked = !this.$model;
                      mi.bind('change', (event: Event) => {
                        this.$model = !(el as any).checked as any;
                      })
             
                      // change
                      mi.watch(() => this.$model, (newValue) => {
                        (el as any).checked = !newValue;
                      })
                    } else {
                      // (el as any).checked = !!this.$model;
                      mi.bind('change', (event: Event) => {
                        this.$model = !!(el as any).checked as any;
                      })
             
                      // change
                      mi.watch(() => this.$model, (newValue) => {
                        (el as any).checked = !!newValue;
                      })
                    }
                    */
                }
                else if (self.$schema.type == 'array') {
                    // let itemType = this.$schema.itemType || "string";
                    const itemType = ((_a = this._internal.schema.items) === null || _a === void 0 ? void 0 : _a.type) || 'string';
                    if (itemType == 'integer' || itemType == 'money' || itemType == 'number') {
                        cvalue = parseFloat(cvalue);
                    }
                    // console.log('cvalue', JSON.stringify({ itemType, value: cvalue }));
                    //(el as any).checked = this.$model && (this.$model as unknown as any[]).indexOf(cvalue) > -1;
                    mi.event('change', ( /* event: Event */) => {
                        const checked = !!el.checked;
                        // let pvalue = self.$model;
                        let nvalue = [];
                        if (checked) {
                            if (self.$model)
                                nvalue = [...self.$model];
                            /*
                            if (!self.$model) {
                              self.$model = [] as any;
                            }
                            */
                            if (nvalue.indexOf(cvalue) == -1) {
                                nvalue.push(cvalue);
                                self.$value = nvalue;
                            }
                        }
                        else {
                            if (!self.$model)
                                return;
                            nvalue = [...self.$model];
                            const ii = nvalue.indexOf(cvalue);
                            if (ii > -1) {
                                nvalue.splice(ii, 1);
                                self.$value = nvalue;
                            }
                        }
                        //model.$model = !!(el as any).checked;
                    });
                    // change
                    mi.watch(() => this.$model.map((x) => x), (newValue) => {
                        el.checked = newValue && newValue.indexOf(cvalue) > -1;
                    }, true);
                }
                else {
                    if (isNumberField)
                        cvalue = parseFloat(cvalue);
                    //(el as any).checked = this.$model === cvalue;
                    mi.event('change', ( /* event: Event */) => {
                        self.$model = el.checked ? cvalue : null;
                    });
                    // change
                    mi.watch(() => this.$model, (newValue) => {
                        el.checked = newValue === cvalue;
                    }, true);
                }
            }
            else {
                // (el as any).value = this.$value;
                mi.event('input', (event) => {
                    const value = event.target.value;
                    // data.svalue = value;
                    this.$value = value;
                });
                // change
                mi.watch(() => this.$value, (newValue) => {
                    if (!isNumberField || !mi.hasFocus) {
                        el.value = newValue;
                    }
                }, true);
            }
            if (!this._internal.mountedItems) {
                this._internal.mountedItems = [];
            }
            this._internal.mountedItems.push(mi);
            return mi;
        }
        else {
            // console.log('bing.tag', el.tagName, modifiers);
            const wfunc = modifiers && modifiers.error ? () => this.$error : () => this.$value;
            // debugger;
            const mi = new MountItem_1.MountItem(el);
            mi.watch(wfunc, (newValue) => {
                el.textContent = newValue;
            }, true);
        }
        return null;
    }
    $unbind(el) {
        var _a;
        if (!el) {
            if (this._internal.mountedItems) {
                for (let i = this._internal.mountedItems.length - 1; i >= 0; i--) {
                    this.$unbind(this._internal.mountedItems[i]);
                }
                return true;
            }
            return false;
        }
        let item;
        if (el instanceof MountItem_1.MountItem) {
            item = el;
        }
        else {
            if (this._internal.mountedItems) {
                item = this._internal.mountedItems.filter((x) => x.el == el)[0];
            }
        }
        if (item !== undefined) {
            // console.log('$unbind', this.$path, el, item);
            item.unbind();
            if (this._internal.mountedItems) {
                const ii = (_a = this._internal.mountedItems) === null || _a === void 0 ? void 0 : _a.indexOf(item);
                if (ii > -1) {
                    this._internal.mountedItems.splice(ii, 1);
                }
                return true;
            }
        }
        return false;
    }
    /**
     * pobranie wartości użytkownika
     *
     * @param {string} field nazwa pola
     * @param {*} [defaultvalue] wartośc domyślna gdy pole nie istnieje
     * @returns {*}
     * @memberof WrappedPropertyBase
     */
    $getUserData(field, defaultvalue) {
        const value = this.$data[field];
        if (value === undefined) {
            if (defaultvalue === undefined) {
                this.$setUserData(field, null);
            }
            else {
                this.$setUserData(field, defaultvalue);
            }
            return this._internal.vmUserData[field];
        }
        return value;
    }
    /**
     * ustawienie danych użytkownika
     *
     * @param {string} field
     * @param {*} value
     * @memberof WrappedPropertyBase
     */
    $setUserData(field, value) {
        this.$data[field] = value;
    }
    /**
     * wymusza wszystkie przeliczenia calc
     * @returns czy funkcja była dostępna (trzeba ją włączyć w opcjach forceCalcEnabled)
     */
    $forceCalc() {
        if (this._options.forceCalcEnabled && this._options._forceRecalc) {
            this._options._forceRecalc.value++;
            return (0, vue_1.nextTick)().then(() => {
                return true;
            });
        }
        return Promise.resolve(false);
    }
    /**
     * niszczenie obiektu i zwalnianie zasobów
     *
     * @memberof WrappedPropertyBase
     */
    $destroy() {
        // console.log("$destroy", this.$path);
        if (this._internal.debounceTimer) {
            if (this._internal.debounceValue && this._internal.debounceValue.value != undefined) {
                this.$setData(this._internal.debounceValue.value, null, true);
            }
            clearTimeout(this._internal.debounceTimer);
        }
        // definitions
        const defs = this._internal.definitions;
        if (defs) {
            for (const key in defs) {
                defs[key].$destroy();
            }
        }
        if (this._options._disabledFields)
            this._options._disabledFields.delete(this.$path);
        // watchStops
        if (this._internal.watchStops) {
            for (let i = 0; i < this._internal.watchStops.length; i++) {
                this._internal.watchStops[i]();
            }
            this._internal.watchStops = [];
        }
        // ref
        if ((0, vue_1.isRef)(this._internal.key)) {
            this._internal.key = { value: this._internal.key.value };
        }
        // usunięcie pola z reded error
        if (this._options._readedErrorFields)
            this._options._readedErrorFields.delete(this);
        //mounted
        this.$unbind();
        if (this._internal.onDestroy) {
            this._internal.onDestroy();
        }
    }
    /**
     * ustawianie $dirty na false
     *
     * @memberof WrappedPropertyBase
     */
    $reset() {
        this.$dirty = false;
    }
    /**
     * lista elementów "dotkniętych", zawiera wszystkie elementy podrzędne
     *
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]}
     * @memberof WrappedPropertyBase
     */
    $dirtyList(result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$schema.disabled)
            return result;
        if (this.$dirty) {
            result.push(this);
        }
        return result;
    }
    /**
     * ustawienie dzieci jako $dirty
     *
     * @param paths lista dzieci do ustawienia
     * @returns liczba dzici ustawionych na $dirty
     */
    $setDirtyChild(paths) {
        let result = 0;
        if (typeof paths === 'string')
            paths = [paths];
        for (let i = 0; i < paths.length; i++) {
            const child = this.$child(paths[i]);
            if (child) {
                child.$dirty = true;
                result++;
            }
        }
        return result;
    }
    /**
     * sprawdzanie ostrzeżeń
     *
     * @param {*} [value] wartość pola
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult] tablica ostrzeżeń
     * @returns {string[]} wynikowa tablica ostrzeżeń
     * @memberof WrappedPropertyBase
     */
    $check(value, skipDirty, checkResult) {
        if (this._internal.schema.warnings && !this.$disabled) {
            if (value === undefined) {
                value = this.$model;
            }
            checkResult = checkResult || [];
            this.$checkResult = [];
            const funcs = (0, getValidations_1.getValidations)(this._internal.schema, this._internal.schema.warnings, true);
            for (const func of funcs) {
                const validation = func(value, this.$schema.warnings);
                if (validation) {
                    const message = (0, getRuleMessage_1.getWarningMessage)(this._internal, validation, value, this.$schema);
                    this.$checkResult.push({
                        validation,
                        message,
                        expected: this.$schema.warnings[validation]
                    });
                    checkResult.push(message);
                }
            }
            if (this.$schema && this.$schema.warningValidFunc) {
                const message = (0, getRuleMessage_1.getWarningMessage)(this._internal, this.$schema.warningValidFunc, value, this.$schema);
                this.$checkResult.push({
                    validation: 'validFunc',
                    message,
                    expected: this.$schema.warningValidFunc
                });
                checkResult.push(message);
            }
            return checkResult;
        }
        return (this.$checkResult = []);
    }
    /**
     * ostrzeżenie z tego pola i pól podrzędnych
     *
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {IWrappedProperty[]} [result]
     * @returns {IWrappedProperty[]}
     * @memberof WrappedPropertyBase
     */
    $checkAll(skipDirty, result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$check(undefined, skipDirty).length) {
            result.push(this);
        }
        return result;
    }
    /**
     * walidacja elementu, zwraza komunikat błędu lub null
     *
     * @param {*} [value] wartość, jak nie podana to bierze z modelu
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)}  komunikat błędu lub null
     * @memberof WrappedPropertyBase
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    $validate(value, skipDirty) {
        // let stime = (new Date()).getTime();
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        const funcs = (0, getValidations_1.getValidations)(this._internal.schema, this._internal.schema, true);
        for (const func of funcs) {
            const validation = func(value, this.$schema);
            if (validation) {
                const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, validation, value, this.$schema);
                this.$validateResult = {
                    validation,
                    message,
                    expected: this.$schema[validation]
                };
                return message;
                // return result;
            }
        }
        if (this._internal.schema.validFunc) {
            if (this.$schema && this.$schema.validFunc) {
                const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, this.$schema.validFunc, value, this.$schema);
                this.$validateResult = {
                    validation: 'validFunc',
                    message,
                    expected: this.$schema.validFunc
                };
                return message;
            }
        }
        return (this.$validateResult = null);
    }
    /**
     * czy pole zawiera walidatory
     */
    get $hasValidators() {
        const funcs = (0, getValidations_1.getValidations)(this._internal.schema, this._internal.schema, true);
        if (funcs.length)
            return true;
        if (this.$schema.fieldRequired)
            return true;
        if (this._internal.schema.validFunc)
            return true;
        return false;
    }
    /**
     * waliduje element i wszystkie podrzędne
     *
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @param {IWrappedProperty[]} [result] tymczasowa tablica lementów
     * @returns {IWrappedProperty[]} wynikowa tablica elementów które nie przeszły walidacji
     * @memberof WrappedPropertyBase
     */
    $validateAll(skipDirty, result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$validate(undefined, skipDirty)) {
            result.push(this);
        }
        return result;
    }
    /**
     * ustawienie domyślnej wartości w polu
     * @returns {boolean} czy udało się ustawić nową wartość
     * @memberof WrappedPropertyBase
     */
    $setDefault() {
        const schema = this._internal.schema;
        const defValue = (0, defaultValue_1.defaultValue)(schema, true, undefined, this._internal.options, this.$path);
        /*
            if (this._options._anyEvent?.change) {
              let prevValue = this.$model;
              if (Array.isArray(prevValue) || isObject(prevValue)) {
                prevValue = deepCopy(prevValue);
              }
              this.$setData(defValue, undefined, true);
              runEvent({ type: 'change', target: this, value: defValue, prevValue })
            } else {
              this.$setData(defValue, undefined, true);
            }
            */
        //$setData zawiera juz runEvent
        this.$setData(defValue, undefined, true);
        if (schema.type === 'array') {
            // jeśli length było wyliczalne to wylicz
            if (this.$schema.length !== undefined && typeof schema.length !== 'number') {
                this.$setLength(this.$schema.length);
            }
        }
        return true;
    }
    /**
     * ustawienie wartości w polu
     *
     * @param {*} value nowa wartość
     * @param {string} [path] ścieżka, przydatna gdy chcemy ustawić wartośc podrzędną
     * @param {boolean} [fixArraySize] czy wymuszac zmianę wielkości tablic
     * @returns {boolean} czy udało się ustawić nową wartość
     * @memberof WrappedPropertyBase
     */
    $setData(value, path, fixArraySize) {
        var _a, _b, _c;
        if (path) {
            return (0, setData_1.setData)(this._internal.schema, this.$model, value, path, 0, fixArraySize, this._options, this.$path);
        }
        else {
            // this._options.Vue.set(this._internal.parent, this.$key, value);
            // lepiej tak bo następuje dopasowanie typu
            if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.beforeChange) {
                const prevValue = this.$model;
                const event = { type: 'beforeChange', target: this, value, prevValue };
                if ((0, functions_1.runEvent)(event)) {
                    if (event.value !== value) {
                        value = event.value;
                    }
                }
            }
            if ((_b = this._options._anyEvent) === null || _b === void 0 ? void 0 : _b.beforeChange) {
                const prevValue = this.$model;
                if (value !== prevValue) {
                    const event = { type: 'beforeChange', target: this, value, prevValue };
                    if ((0, functions_1.runEvent)(event)) {
                        if (event.value !== value) {
                            value = event.value;
                        }
                    }
                }
            }
            //to jest typ prosty
            if ((_c = this._options._anyEvent) === null || _c === void 0 ? void 0 : _c.change) {
                const prevValue = this.$model;
                if ((0, setData_1.setDataValue)(this.$schema, this._internal.parent, this.$key, value)) {
                    // console.log('$setData', this.$path, value);
                    if (prevValue !== value) {
                        const event = { type: 'change', target: this, value, prevValue };
                        (0, functions_1.runEvent)(event);
                        if (value !== event.value) {
                            //zostało zmienione, co teraz ?
                            (0, setData_1.setDataValue)(this.$schema, this._internal.parent, this.$key, event.value);
                        }
                    }
                    return true;
                }
                return false;
            }
            else {
                return (0, setData_1.setDataValue)(this.$schema, this._internal.parent, this.$key, value);
            }
        }
    }
    $setNewData(value, path) {
        if (path) {
            return (0, setNewData_1.setNewData)(this._internal.schema, this.$model, value, path, 0, this._internal.options);
        }
        else {
            if (value === undefined) {
                //defaultValue(pschema, true, undefined, longGuids);
                return (0, setData_1.setDataValue)(this.$schema, this._internal.parent, this.$key, (0, defaultValue_1.defaultValue)(this._internal.schema, true, null, this._internal.options, this.$path));
            }
            else {
                return (0, setData_1.setDataValue)(this.$schema, this._internal.parent, this.$key, value);
            }
        }
    }
    /**
     * pobranie danych, omija pola `computed` i inne niezgodne ze schematem
     *
     * @param {boolean} [checkDataType] czy sprawdzać typy, jeśli true to nie zwraca pól z nieprawidłowymi wartościami
     * @returns {*} wyczyszczone dane modelu
     * @memberof WrappedPropertyBase
     */
    $getData(checkDataType, path) {
        if (path) {
            const childObj = this.$child(path);
            if (childObj)
                return childObj.$getData(checkDataType);
            else
                return undefined;
        }
        return (0, clearData_1.clearData)(this._internal.schema, this.$model, checkDataType !== false, this._options, this.$path);
    }
    $getDataJson(checkDataType, path) {
        return JSON.stringify(this.$getData(checkDataType, path));
    }
    /**
     * pobranie danych, omija pola `computed` i inne niezgodne ze schematem
     *
     * @param {boolean} [checkDataType] czy sprawdzać typy, jeśli true to nie zwraca pól z nieprawidłowymi wartościami
     * @returns {*} wyczyszczone dane modelu
     * @memberof WrappedPropertyBase
     */
    $clearDataDefaults(path) {
        if (path) {
            const childObj = this.$child(path);
            if (childObj)
                return childObj.$clearDataDefaults();
            else
                return undefined;
        }
        return (0, clearDataDefaults_1.clearDataDefaults)(this._internal.schema, this.$model, true, this._options, this.$path);
    }
    $getInvalidValues(res = []) {
        return res;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    $setInvalidValues(res) { }
    /**
     * pobiera dziecko na podstawie ścieżki
     * @param path ścieżka w fortmacie pole.tablica[0].property
     */
    $child(path, createArrayItems = false) {
        if (!path)
            return this;
        let restPath = '';
        const epos = path.indexOf('.');
        if (epos > -1) {
            restPath = path.substring(epos + 1);
            path = path.substring(0, epos);
        }
        /*
        let aindex = NaN;
        if (apos > -1) {
          aindex = +path.substring(apos + 1, path.indexOf(']', apos));
          path = path.substring(0, apos);
        }
        */
        //root
        if (path === '$') {
            return this.$root.$child(restPath, createArrayItems);
        }
        const apos = path.indexOf('[');
        switch (this._internal.schema.type) {
            case 'object':
                if (apos > -1) {
                    const obj = this[path.substring(0, apos)];
                    if (obj)
                        return obj.$child(path.substring(apos) + '.' + restPath, createArrayItems);
                }
                else {
                    const obj = this[path];
                    if (obj)
                        return obj.$child(restPath, createArrayItems);
                }
                break;
            case 'array':
                if (apos > -1) {
                    const sindex = path.substring(apos + 1, path.indexOf(']', apos));
                    let aindex = +sindex;
                    if (isNaN(aindex)) {
                        // po guid
                        aindex = this.$model.findIndex((x) => x.guid == sindex || x.Guid == sindex);
                        if (aindex == -1)
                            return undefined;
                    }
                    if (aindex >= this.$items.length && createArrayItems) {
                        while (this.$items.length <= aindex) {
                            this.$addRow();
                        }
                    }
                    const sitem = this.$items[aindex];
                    if (sitem) {
                        return sitem.$item.$child(restPath, createArrayItems);
                    }
                }
                break;
        }
        return undefined;
    }
    /**
     * pobiera wszystkie pola, wiadomo działa tylko na typie object, dla innych zwraca pusty obiekt
     */
    get $fields() {
        return {};
    }
    /**
     * zdarzenie przed zmianą ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    beforePathChange() {
        const disabled = this.$schema.disabled;
        if (disabled && this._options._disabledFields) {
            this._options._disabledFields.delete(this.$path);
        }
    }
    /**
     * zdarzenie po zmianie ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    afterPathChange() {
        const disabled = this.$schema.disabled;
        if (disabled) {
            if (!this._options._disabledFields)
                this._options._disabledFields = new Set();
            this._options._disabledFields.add(this.$path);
        }
    }
    /**
     * aktualizacja
     *
     * @param {*} newKey
     * @memberof WrappedPropertyBase
     */
    $changeKey(newKey) {
        this.beforePathChange();
        this._internal.key.value = newKey;
        this._internal.mparent = this._internal.parent[newKey];
        this.afterPathChange();
    }
    /**
     * $parent.$parent
     *
     * @readonly
     * @type {(IWrappedProperty | null)}
     * @memberof WrappedPropertyBase
     */
    get $parent2() {
        if (!this.$parent) {
            return null;
        }
        return this.$parent.$parent;
    }
    /**
     * $parent.$parent.$parent
     *
     * @readonly
     * @type {(IWrappedProperty | null)}
     * @memberof WrappedPropertyBase
     */
    get $parent3() {
        if (!this.$parent2) {
            return null;
        }
        return this.$parent2.$parent;
    }
    /**
     * usuwanie bierzącego wiersza z tablicy
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    $removeRow(index) {
        if (this.$isArrayItem) {
            if (index !== undefined)
                return this.$parent.$removeRow(index);
            return this.$parent.$removeRow(this.$key);
        }
        return false;
    }
    /**
     * przesuwanie bieżącego wiersza tablicy w górę
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    $moveUp(index) {
        if (this.$isArrayItem) {
            if (index !== undefined)
                return this.$parent.$moveUp(index);
            return this.$parent.$moveUp(this.$key);
        }
        return false;
    }
    /**
     * przesuwanie bieżącego wiersza tablicy w dół
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    $moveDown(index) {
        if (this.$isArrayItem) {
            if (index !== undefined)
                return this.$parent.$moveDown(index);
            return this.$parent.$moveDown(this.$key);
        }
        return false;
    }
    /**
     * czyszczenie bieżącego wiersza tablicy, nadawanie wartości domyślnych
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    $clearRow(index) {
        if (this.$isArrayItem) {
            if (index !== undefined)
                return this.$parent.$clearRow(index);
            return this.$parent.$clearRow(this.$key);
        }
        return false;
    }
    /**
     * naprawianie formatu daty
     *
     * @returns {number}
     * @memberof WrappedPropertyBase
     */
    $fixDateFormat() {
        return 0;
    }
    /**
     * pobranie wartości z modelu
     *
     * @protected
     * @returns {*}
     * @memberof WrappedPropertyBase
     */
    getValue(modelValue) {
        return modelValue != undefined ? modelValue : this.$model;
    }
    /**
     * ustawienie wartości na modelu
     *
     * @protected
     * @param {*} newValue
     * @memberof WrappedPropertyBase
     */
    setValue(newValue) {
        var _a;
        if (!this.$schema.disabled) {
            if (!this.$dirty && this._internal.options.dirtyOnInput) {
                this.$dirty = true;
            }
            this._options._userInput = true;
        }
        if ((_a = this._options._anyEvent) === null || _a === void 0 ? void 0 : _a.change) {
            let prevValue = this.$model;
            if (Array.isArray(prevValue) || (0, defineSchema_1.isObject)(prevValue)) {
                prevValue = (0, schemaMethods_1.deepCopy)(prevValue);
            }
            this.$model = newValue;
            (0, functions_1.runEvent)({ type: 'change', target: this, value: newValue, prevValue });
        }
        else {
            this.$model = newValue;
        }
    }
    /**
     * pobranie pól z definicji
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    get $definitions() {
        if (this._internal.definitions) {
            return this._internal.definitions;
        }
        let result = null;
        if (this._internal.schema.definitions) {
            result = {};
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const self = this;
            for (const key in this._internal.schema.definitions) {
                const sobj = this._internal.schema.definitions[key];
                let cache = null;
                Object.defineProperty(result, key, {
                    get() {
                        if (cache) {
                            return cache;
                        }
                        else {
                            return (cache = new WrappedPropertyCtor_1.WrappedPropertyCtor[sobj.type || 'string']({
                                dest: self,
                                parent: {},
                                propName: key,
                                schema: sobj,
                                options: self._internal.options
                            }));
                            //self, {}, key, sobj, self._internal.options
                        }
                    }
                });
            }
        }
        return (this._internal.definitions = result);
    }
    /**
     * zaczyna rejestrację odczytu właściwości $error dla pól
     */
    $startRegisterErrorProps() {
        this._options._readedErrorFields = new Set();
        return true;
    }
    /**
     * pobieranie listy zarejestrowanych właściwości których odczytywano $error
     * @returns
     */
    $getErrorProps() {
        var _a;
        return (_a = this._options._readedErrorFields) !== null && _a !== void 0 ? _a : new Set();
    }
    /**
     * kończy rejestrację odczytu własciwości $error dla pól
     * @returns zwraca zestaw zarejestrowanych właściwości
     */
    $stopRegisterErrorProps() {
        const result = this.$getErrorProps();
        this._options._readedErrorFields = undefined;
        return result;
    }
    $traverseFirst(predicate, allProps) {
        if ((allProps || !this.$schema.disabled) && predicate(this))
            return this;
    }
    $changeLanguage(lang, skipi18) {
        if (this._options._lang) {
            this._options._lang.value = (0, lang_1.createLang)(lang);
            if (!skipi18 && this._options._i18n) {
                const previ18 = this._options._i18n.value;
                if (previ18 && previ18.language !== lang) {
                    const instance = previ18.instance;
                    instance.changeLanguage(lang);
                    this._options._i18n.value = {
                        t: instance.t,
                        language: lang,
                        instance
                    };
                }
            }
            return true;
        }
        return false;
    }
    $setExternal(external) {
        if (this._options.external &&
            (0, defineSchema_1.isObject)(this._options.external) &&
            (0, vue_1.isReactive)(this._options.external) &&
            (0, defineSchema_1.isObject)(external)) {
            Object.assign(this._options.external, external);
        }
        else {
            this._options.external = external;
        }
    }
    get $anyError() {
        let result = false;
        this.$traverseFirst((prop) => {
            //if (prop.$error)
            // console.log('traverse', prop.toString());
            if (!prop.$schema.disabled &&
                // && (prop as any)._internal.vmUserData
                // && (prop as any)._internal.vmUserData.$dirty
                prop.$dirty && //żeby było reaktywnie
                prop.$validate(undefined, true)) {
                result = true;
                // wyłacz return aby przeszło wszystkie property, żeby było reaktywnie
                return true;
            }
        });
        return result;
    }
    get $anyWarning() {
        const checkResult = [];
        let result = false;
        this.$traverseFirst((prop) => {
            // if (prop.$warnings.length)
            if (!prop.$schema.disabled &&
                // && (prop as any)._internal_internal.vmUserData
                //&& (prop as any)._internal_internal.vmUserData.$dirty
                prop.$dirty && //zeby było reactive
                prop.$check(undefined, true, checkResult).length) {
                result = true;
                return true;
            }
        });
        return result;
    }
    $on(eventName, eventFunction) {
        return (0, functions_1.addEvent)(this, eventName, eventFunction);
    }
    $off(eventName, eventFunction) {
        return (0, functions_1.removeEvent)(this, eventName, eventFunction);
    }
    /**
     * zwraca ścieżkę
     * @returns
     */
    toString() {
        if (this.$parent) {
            return '$.' + this.$path;
        }
        else {
            return '$';
        }
    }
}
exports.WrappedPropertyBase = WrappedPropertyBase;
exports.default = WrappedPropertyBase;
//# sourceMappingURL=WrappedPropertyBase.js.map